import React from 'react'
import { Clock, AlertCircle, CheckCircle } from 'lucide-react'

const PendingLeaves = () => {
  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Pending Leaves</h1>
          <p className="text-gray-600">Review and approve pending leave requests</p>
        </div>
      </div>

      {/* Coming Soon Card */}
      <div className="bg-white rounded-lg shadow-md p-8 text-center">
        <div className="flex justify-center mb-4">
          <div className="bg-orange-100 p-3 rounded-full">
            <Clock className="w-8 h-8 text-orange-600" />
          </div>
        </div>
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Coming Soon</h2>
        <p className="text-gray-600 mb-6">
          Pending leaves management feature is under development. 
          This will include functionality to review, approve or reject leave applications.
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          <div className="text-center">
            <div className="bg-orange-100 p-2 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-3">
              <AlertCircle className="w-6 h-6 text-orange-600" />
            </div>
            <h3 className="font-semibold text-gray-900">Review Requests</h3>
            <p className="text-sm text-gray-600">View detailed leave applications</p>
          </div>
          
          <div className="text-center">
            <div className="bg-green-100 p-2 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-3">
              <CheckCircle className="w-6 h-6 text-green-600" />
            </div>
            <h3 className="font-semibold text-gray-900">Quick Approval</h3>
            <p className="text-sm text-gray-600">Approve or reject with comments</p>
          </div>
          
          <div className="text-center">
            <div className="bg-blue-100 p-2 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-3">
              <Clock className="w-6 h-6 text-blue-600" />
            </div>
            <h3 className="font-semibold text-gray-900">Status Tracking</h3>
            <p className="text-sm text-gray-600">Track application status changes</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PendingLeaves
